import { render, staticRenderFns } from "./CustomerList.vue?vue&type=template&id=6485e5d5&scoped=true"
import script from "./CustomerList.vue?vue&type=script&lang=ts"
export * from "./CustomerList.vue?vue&type=script&lang=ts"
import style0 from "./CustomerList.vue?vue&type=style&index=0&id=6485e5d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6485e5d5",
  null
  
)

export default component.exports